import React, { Component } from "react";
import { Collapse, Empty } from "antd";
import Widget from "../../Theme/Widget";
// import 'react-calendar-timeline/lib/Timeline.css'
import DetailedScheduleDayType from './DetailedScheduleDayType';
import getOffsetTime from '../../../utils/getOffsetTime';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

const { Panel } = Collapse;

const DetailedScheduleTable = (props) => {
  return (
    <React.Fragment>
      {props.detailedSchedule.length > 0 ?
        (<Widget>
          <Collapse>
            {props.detailedSchedule.map((schedule, index) => (
              <Panel key={index} header={moment.unix(schedule.rdtDate).add(getOffsetTime(moment.unix(schedule.rdtDate)), 'minutes').format('dddd, MMMM Do YYYY') || ""}>
                <DetailedScheduleDayType
                  offset={getOffsetTime(moment.unix(schedule.rdtDate))}
                  detailedSchedule={schedule}
                  resourceName={props.resourceName}
                  index={index}
                  openModal={props.openModal}
                  canEdit={props.user.mobileSecurity.canEdit}
                  securityLevels={props.user.securityLevels}
                  resourcesId={props.resourcesId}
                />
              </Panel>
            ))}
          </Collapse>
        </Widget>)
        :
        (<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />)
      }
    </React.Fragment>
  )
}

DetailedScheduleTable.propTypes = {
  detailedSchedule: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  return {
    user: state.user,
    detailedSchedule: state.detailedSchedules.detailedSchedules,
  }
}

export default connect(
  mapStateToProps,
)(DetailedScheduleTable);


// WEBPACK FOOTER //
// ./src/Components/Schedule/DetailedSchedule/DetailedScheduleTable.js